module.exports = __webpack_public_path__ + "static/media/Lesotho.b6fa6dab.png";